/**
 *
 * Ask
 *
 */

import { mapMutations } from 'vuex';
import _ from 'lodash';

import { NoteContentMixin } from '@/mixins/Note/Content';

import { DEBOUNCE_LATENCY } from '@/constants';
import { getIsOldChrome } from '@/utils/browser';

export const NoteMixin = {
  name: 'NoteMixin',

  mixins: [NoteContentMixin],

  data: () => {
    return {
      isNeedSaveNote: false,

      editable: false,

      promiseUpdateNote: null,

      isOldChrome: getIsOldChrome(),
    };
  },

  methods: {
    ...mapMutations('Mixins/Note', {
      mm_SET_IS_NOTE_FETCHED: 'SET_IS_NOTE_FETCHED',
      mm_SET_IS_NOTE_SAVING: 'SET_IS_NOTE_SAVING',
      mm_SET_IS_NOTE_SAVED: 'SET_IS_NOTE_SAVED',
      mm_SET_DATE_NOTE_SAVED: 'SET_DATE_NOTE_SAVED',
      mm_SET_IS_SAVE_IMMEDIATELY: 'SET_IS_SAVE_IMMEDIATELY',
    }),

    //
    async fetchNote() {
      //
    },

    async fetchNoteAndUpdateEditor(payload) {
      if (this.isOldChrome) {
        return;
      }
      this.editable = false;
      this.mm_SET_IS_NOTE_FETCHED(false);
      this.mm_SET_IS_NOTE_SAVING(false);
      this.mm_SET_IS_NOTE_SAVED(false);
      this.mm_SET_DATE_NOTE_SAVED('');
      const noteContent = await this.fetchNote(payload);
      this.isNeedSaveNote = true;
      this.noteContent = noteContent;
      this.editable = true;
      this.mm_SET_IS_NOTE_FETCHED(true);
    },

    //
    async updateNote() {
      //
    },

    async saveNote(payload) {
      if (!this.isNeedSaveNote) {
        return;
      }
      this.mm_SET_IS_SAVE_IMMEDIATELY(payload.isSaveImmediately);
      this.mm_SET_IS_NOTE_SAVING(true);
      this.mm_SET_IS_NOTE_SAVED(false);
      const promiseUpdateNote = this.updateNote(payload);
      this.promiseUpdateNote = Promise.all([promiseUpdateNote, ...this.allPromiseUploadImg]);
      await this.promiseUpdateNote;
      const date = new Date();
      let dateNoteSaved = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      dateNoteSaved += ` ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      this.mm_SET_DATE_NOTE_SAVED(dateNoteSaved);
      this.mm_SET_IS_NOTE_SAVING(false);
      this.mm_SET_IS_NOTE_SAVED(true);
    },

    handleSaveNote(payload) {
      if (payload.isSaveImmediately) {
        this.de_saveNote.cancel();
        this.saveNote(payload);
      } else {
        this.de_saveNote(payload);
      }
    },

    ///
    handleSave({ isSaveImmediately }) {
      this.handleSaveNote({ isSaveImmediately });
    },

    async flushSaveNote() {
      if (this.isOldChrome) {
        return;
      }
      this.editable = false;
      this.de_saveNote.flush();
      await this.promiseUpdateNote;
      this.mm_SET_IS_NOTE_FETCHED(false);
      this.mm_SET_IS_NOTE_SAVING(false);
      this.mm_SET_IS_NOTE_SAVED(false);
      this.mm_SET_DATE_NOTE_SAVED('');
      this.isNeedSaveNote = false;
      this.noteContent = '';
      return this.promiseUpdateNote;
    },
  },

  created() {
    this.de_saveNote = _.debounce(this.saveNote, DEBOUNCE_LATENCY * 5);
  },

  beforeDestroy() {
    this.flushSaveNote();
  },
};

export default NoteMixin;
